export const DEFAULT_DURATION = 300;
export const TRANSITIONS = {
  RISE_TOP: "rise-top",
  RISE_RIGHT: "rise-right",
  RISE_BOTTOM: "rise-bottom",
  RISE_LEFT: "rise-left",
  FADE: "fade",
} as const;
